
<div class="row justify-content-center position-relative col-12" style="margin-top: 15vh;">
  <div style="margin-left: 10%; margin-right: 5%;">
    <div style="z-index: 100;background-color: white;" class="row mt-2 mr-0 d-flex">
      <h1 class="font-weight-bold text-uppercase ml-2">Queue</h1>
      <div class="filter-icon ml-auto">
        <button class="btn btn-filter text-white mr-2 trigger-collapse-btn" title="Filter" data-toggle="collapse" data-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
          <i class='fas fa-filter'></i></button>
        <button class="btn text-white mr-2 trigger-collapse-btn" title="Refresh" (click)="refreshList()">
          <i class="fas fa-sync-alt"></i></button>
      </div>
    </div>
    <div class="filterContent">
      <div class="collapse " id="collapseExample">
        <form class="row" [formGroup]="searchQueueForm" (submit)="searchQueue(searchQueueForm.value)">
          <div class="col">
            <ng-select class="custom-style" [multiple]="true" id="my-project" chosen formControlName="projectIds" placeholder="Select Project(s)" [items]="userProjects" bindLabel="name" bindValue="id" (change)="getUsersByProject(projectIdsValue)">
              <ng-template ng-option-tmp let-item="item">
                <div title="{{item.name}}" class="text-truncate">{{item.name}}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col" [hidden]="!projectIdsValue || projectIdsValue?.length === 0">
            <ng-select class="custom-style" [multiple]="true" id="project-user" chosen formControlName="userIds" placeholder="Select Users(s)" bindLabel="displayName" bindValue="id" [items]="projectUsers" [ngClass]="{'disabled': !projectIdsValue || projectIdsValue?.length === 0}"></ng-select>

          </div>
          <div class="col" *ngIf="!projectIdsValue || projectIdsValue?.length === 0">
            <input id="search-userName" class="form-control form-control-sm" placeholder="Search User" formControlName="userName">
          </div>
          <div class="col">

            <ng-select class="custom-style" chosen formControlName="executionStatus" [items]="executionStatuses" placeholder="Select Status" [clearable]="true"></ng-select>
          </div>
          <div class="col">
            <input id="search-keyword" class="form-control form-control-sm" placeholder="Search Keyword" formControlName="keyword">
          </div>
          <div class="col-12 mt-3 mb-3 d-flex justify-content-end">
            <button type="submit" class="btn btn-sm btn-primary mr-2">Search</button>
            <button type="clear" class="btn btn-sm btn-warning" (click)="clearFilterQueue()">Clear</button>
          </div>
        </form>
      </div>
    </div>
    <table class="table list-table-design">
      <thead class="TableHead">
        <tr class="list-table-row">
          <th class="text-left" (click)="sortByColumn('name')" width="20%">Testname</th>
          <th class="text-center" (click)="sortByColumn('loadTestType')" width="9.5%">Type</th>
          <th class="text-center" width="8%" (click)="sortByColumn('location')">Location</th>
          <th class="text-center" [style.width]="userData.perfLabAdmin ? '5%' : '12.5%'" title="Transactions per minute" (click)="sortByColumn('noOfUsers')">Users/TPM</th>
          <th class="text-center" width="30%" (click)="sortByColumn('startTime')">Schedule Date & Time (PST)</th>
          <th class="text-center" width="7.5%" (click)="sortByColumn('status')">Status</th>
          <th class="text-left" width="7.5%" *ngIf="userData.perfLabAdmin" (click)="sortByColumn('userName')">Created By</th>
          <th class="text-right" width="12.5%"></th>
        </tr>
      </thead>
      <tbody>
        <div *ngIf="collectionSize === 0" style="display: grid;" class="mt-5 pt-5 justify-content-center">
          <img height="100px" src="/assets/images/icons/empty_message.png" alt="/assets/images/icons/empty_message.png">
          <p style="color: gray;" class="ml-3 mt-1"><b>No Data Found</b></p>
        </div>
        <tr>
        <tr *ngFor="let queueData of queueData?.performanceRequests" class="clickable">
          <td class="text-truncate" width="20%">
            <span style="display: flex; align-items: center;">
              <a><i class="fas fa-link" ngbTooltip="Go to Testcase" container="body" (click)="getTestCaseList(queueData.testCase.id)"></i></a>
              <a class="text-truncate" [routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']" title="{{queueData.testCase.name}}" style="padding-left: 0.3em;">{{queueData.testCase?.name}}</a>
            </span>
          </td>
          <td class="text-truncate text-center" width="9.5%">{{queueData.testCase?.loadTestType}}</td>
          <td class="text-truncate text-center" width="7.5%">
            <a [routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']">{{queueData.location
                ? queueData.location : 'NA'}}</a>
          </td>
          <td class="text-truncate text-center" [style.width]="userData.perfLabAdmin ? '5%' : '12.5%'">
            <a [routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']">{{queueData.noOfUsers
                > 9 ?
                queueData.noOfUsers : '0' + queueData.noOfUsers}}</a>
          </td>
          <td class="text-truncate text-center" width="30%" title="{{queueData.status === 'SCHEDULED' ? 'Results are not ready' : null}}">
            <a [routerLink]="['/performance/loadTesting/result', queueData.id, 'queue']">
              {{queueData.startTime | date: 'd-MM-yy, hh:mm:ss a'}} - {{queueData.endTime | date:'d-MM-yy, hh:mm:ss a'}}
            </a>
          </td>
          <td class="text-center" width="7.5%">
            <div class="status-badge status-{{ queueData.status.toLowerCase() }}" [title]="queueData.status">
              <i class="fas" [ngClass]="{
                    'fa-check-circle': queueData.status === 'PASSED',
                    'fa-times-circle': queueData.status === 'FAILED',
                    'fa-sync-alt fa-spin': queueData.status === 'IN_PROGRESS',
                    'fa-clock': queueData.status === 'SCHEDULED',
                    'fa-hand-paper': queueData.status === 'ABORTED',
                    'fa-hourglass-half': queueData.status === 'PENDING'
                  }"></i>
              <!-- {{ queueData.status }} -->
            </div>
          </td>
          <td class="text-truncate" width="7.5%" *ngIf="userData.perfLabAdmin" title="{{queueData.createdBy?.displayName}}">
            <span style="font-size:11px">{{queueData.createdBy ? queueData.createdBy.userName : ''}}</span>
          </td>
          <td class="text-right" width="12.5%">
            <div class="action-buttons">
              <button class="btn btn-sm btn-icon" title="Re-run" *ngIf="!queueData.usingJmxFile" [routerLink]="['/performance/loadTesting/rerun/', queueData.id]">
                <i class="fas fa-redo"></i>
              </button>
              <button class="btn btn-sm btn-icon" title="Re-run" *ngIf="queueData.usingJmxFile" [routerLink]="['/performance/loadTesting/jmx-upload', queueData.id]">
                <i class="fas fa-redo"></i>
              </button>
              <button class="btn btn-sm btn-icon text-danger" (click)="abortRunningTest(queueData.id)" title="Abort"
                *ngIf="queueData.status === 'SCHEDULED' || queueData.status === 'IN_PROGRESS' || queueData.status === 'PENDING'">
                <i class="fas fa-hand-paper"></i>
              </button>
              <button class="btn btn-sm btn-icon text-danger" *ngIf="queueData.status !== 'SCHEDULED' && userData.perfLabAdmin"
                (click)="deleteQueueRes(queueData.id)" title="Delete">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </tr>
        <div *ngIf="queueData?.performanceRequests?.length === 0 && collectionSize && collectionSize !== 0">
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
          <p class="placeholder-glow py-1" style="height: 30px;color: black;">
            <span class="col-12"></span>
          </p>
        </div>
      </tbody>
    </table>
    <div class="row my-4 pb-5" *ngIf="queueData?.performanceRequests?.length > 0">
      <div class="col font-weight-bold">Total Results : {{ collectionSize || 0 }}</div>
      <div class="col-1" *ngIf="queueData?.performanceRequests">
        <select class="" (change)="onSizeChange(pageSize)" [(ngModel)]="pageSize">
          <option>15</option>
          <option>25</option>
          <option>50</option>
          <option>100</option>
        </select>
      </div>
      <div class="col-md-auto" *ngIf="queueData?.performanceRequests?.length && queueData?.performanceRequests?.length">
        <ngb-pagination class="d-flex justify-content-end" [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [(page)]="page" [boundaryLinks]="true" [rotate]="true" (pageChange)="onPageChange($event)"></ngb-pagination>
      </div>
    </div>
  </div>
</div>
